import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../../tabs/applications/applications-routing.constants";
import memo from "memo-decorator";
let ModuleLinkPipe = class ModuleLinkPipe {
    transform(systemModules) {
        const links = new Array();
        systemModules?.forEach(systemModule => {
            const link = AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(systemModule.id, ApplicationsRoutingConstants.APPLICATIONS_ROUTE);
            links.push({ text: link, address: systemModule.name, data: systemModule.id });
        });
        return links.sort((a, b) => 0 - (a.address.toLowerCase() > b.address.toLowerCase() ? -1 : 1));
    }
};
__decorate([
    memo()
], ModuleLinkPipe.prototype, "transform", null);
ModuleLinkPipe = __decorate([
    Pipe({
        standalone: false,
        name: "moduleLink",
        pure: true
    })
], ModuleLinkPipe);
export { ModuleLinkPipe };
